module.exports = __webpack_public_path__ + "img/logo.33aae36d.png";